// extracted by mini-css-extract-plugin
module.exports = {"heading":"CommunityPage_heading__3viTN","content":"CommunityPage_content__1ifuY","linkActive":"CommunityPage_linkActive__1QPGf"};